// removed by extract-text-webpack-plugin
module.exports = {"root":"cms__Sidebar__root","sidebar":"cms__Sidebar__sidebar"};


//////////////////
// WEBPACK FOOTER
// ./containers/Sidebar.css
// module id = 563
// module chunks = 0